import React from 'react';
import './TaglineSection.css';

const TaglineSection = () => {
  return (
    <div className="tagline-card">
      <div className="tagline-content">
        <h3>Sriram Shopping Cart</h3>
        <p>One dashboard for inventory, product control, and quick order readiness.</p>
        <div className="company-badge">
          <span className="powered-by">Made by</span>
          <span className="company-name">Sri ram</span>
        </div>
      </div>
    </div>
  );
};

export default TaglineSection;
